module.exports = __webpack_public_path__ + "static/media/resume.fdaedb34.pdf";